export const DEFAULT_ITEM_HEIGHT = 44;
export const pickerProps = {
    title: String,
    loading: Boolean,
    readonly: Boolean,
    disabled: Boolean,
    itemHeight: [Number, String],
    showToolbar: Boolean,
    cancelButtonText: String,
    confirmButtonText: String,
    allowHtml: {
        type: Boolean,
        default: true,
    },
    visibleItemCount: {
        type: [Number, String],
        default: 6,
    },
    swipeDuration: {
        type: [Number, String],
        default: 1000,
    },
};
